import React, { useContext } from 'react';

import { ErrorHandlerContextValue, ErrorState } from './types';

export const ErrorHandlerContext = React.createContext<ErrorHandlerContextValue | null>(null);

export const ErrorPropsContext = React.createContext<ErrorState>({ name: null });

export const useCurrentError = () => useContext(ErrorPropsContext);

const useErrorHandlerContext = (): ErrorHandlerContextValue => {
    const context = useContext(ErrorHandlerContext);

    if (!context) {
        throw new Error('useErrorHandlerContext must be used within ErrorBoundaryContext');
    }

    return context;
};

export const useHandleError = () => useErrorHandlerContext().handleError;
export const useCleanError = () => useErrorHandlerContext().cleanError;

const noopAddErrorData = () => {};
export const useAddErrorData = () => {
    const context = useContext(ErrorHandlerContext);
    return context?.addErrorData ?? noopAddErrorData;
};
